const COLOURS = {
  purple: '#713bdb',
  deepPurple: '#20154e',

  cardGrey: '#46434a',
  sectionGrey: '#46434a',
  lightGrey: '#f5f6fa',
  mediumGrey: '#808191',
  middleGrey: '#c3ccd5',

  successGreen: '#33d69f',
  errorRed: '#dc5261',

  dark: '#15112d',
  light: '#fff',

  lightBlue: '#49B8FF',
  pink: '#DC3FB9',
  turquoise: '#33D69F',
};

export default COLOURS;
